module.exports = __webpack_public_path__ + "img/mask-1.7b356e33.svg";